export const KB_BASE_URL = 'https://noodlefactorysupport.super.site'
export const KB_PATHS = {
  PERSONAS_LIST: `${KB_BASE_URL}/new-to-noodle-factory-get-started-here/ai-personas`,
  CREATING_KNOWLEDGE_GROUPS: `${KB_BASE_URL}/knowledge-base/creating-knowledge-groups`,
  CREATING_A_QUIZ: `${KB_BASE_URL}/creating-a-quiz`,
}
